'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { IoCalendarOutline, IoArrowBack, IoArrowForward } from 'react-icons/io5';

interface RoomDetailCtasProps {
  roomSlug: string;
  nextRoom: {
    slug: string;
    name: string;
  } | null;
}

export function RoomDetailCtas({ roomSlug, nextRoom }: RoomDetailCtasProps) {
  const t = useTranslations('roomDetail.cta');

  const handleBookNow = () => {
    // Scroll to top of page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Dispatch custom event to highlight the calendar in RoomHero
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('highlight-calendar', { detail: { roomSlug } }));
    }, 600);
  };

  return (
    <section className="bg-white w-full border-t border-black/10">
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-20 flex flex-col items-center gap-6">
        <h2 className="text-2xl md:text-3xl font-semibold font-poppins text-center text-black/90">
          {t('heading')}
        </h2>

        <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
          {/* Primary: Book Now */}
          <button
            onClick={handleBookNow}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-sm font-bold uppercase tracking-wider transition-all duration-300 bg-[#801515] text-white hover:bg-[#601010] cursor-pointer"
          >
            <IoCalendarOutline size={18} />
            {t('bookNow')}
          </button>

          {/* Secondary: Back to Rooms */}
          <Link
            href="/rooms"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-sm font-bold uppercase tracking-wider transition-all duration-300 bg-black/5 text-black/70 border border-black/10 hover:bg-black/10 hover:text-black"
          >
            <IoArrowBack size={18} />
            {t('backToRooms')}
          </Link>

          {/* Secondary: Next Room */}
          {nextRoom && (
            <Link
              href={`/rooms/${nextRoom.slug}`}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-sm font-bold uppercase tracking-wider transition-all duration-300 bg-black/5 text-black/70 border border-black/10 hover:bg-black/10 hover:text-black"
            >
              {t('nextRoom')}
              <IoArrowForward size={18} />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
